import { CollectionViewer, DataSource } from '@angular/cdk/collections';
import { BehaviorSubject, Observable, Subject, Subscription } from 'rxjs';

export class TableDataSource<T> extends DataSource<T> {
  private subscription: Subscription;

  public data = new BehaviorSubject<T[]>([]);
  public viewChange = new Subject<{ start: number; end: number }>();

  connect(collectionViewer: CollectionViewer): Observable<T[]> {
    this.subscription = collectionViewer.viewChange.subscribe((range) => this.viewChange.next(range));

    return this.data.asObservable();
  }

  disconnect(): void {
    this.subscription.unsubscribe();
  }
}
